import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { profile, sections } from '../data/profile';
const ease = [0.23, 1, 0.32, 1] as const;
export function SiteNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  return <header className="sticky top-0 z-50 border-b border-white/10 bg-navy/95 backdrop-blur" data-id="element-133" data-mp="31mayhsvuam1v">
      <div className="mx-auto flex max-w-shell items-center justify-between gap-6 px-6 py-3.5 lg:px-10" data-id="element-134" data-mp="2wnrc5rdc388z">
        <Link to="/" className="shrink-0 font-display text-lg leading-none text-paper transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-135" data-mp="2rnv8jt8jtity">
          {profile.name}
        </Link>

        <nav aria-label="Sections" className="hidden items-center gap-5 xl:flex" data-id="element-136" data-mp="pvyyko214h1a">
          {sections.map(s => <NavLink key={s.path} to={s.path} end={s.path === '/'} className={({
          isActive
        }) => `whitespace-nowrap border-b pb-0.5 text-[12px] uppercase tracking-[0.1em] transition-colors duration-150 ease-out ${isActive ? 'border-gold-soft text-gold-soft' : 'border-transparent text-white/65 hover:text-paper'}`} data-id="element-137" data-mp="kygnar0jhpq4">
              {s.label}
            </NavLink>)}
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="section-menu" className="inline-flex items-center gap-2 border border-white/25 px-3.5 py-2 text-[11px] uppercase tracking-overline text-paper transition-colors duration-150 ease-out hover:border-gold-soft hover:text-gold-soft xl:hidden" data-id="element-138" data-mp="wpq0pqt1ht4z">
          {open ? <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-139" data-mp="1fgpv57jazv5n" /> : <MenuIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="1pc6lmeg50oze" />}
          Sections
        </button>
      </div>

      <AnimatePresence initial={false} data-id="element-141" data-mp="1kdmzoe1jnd71">
        {open && <motion.div id="section-menu" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease
      }} className="overflow-hidden border-t border-white/10 xl:hidden" data-id="element-142" data-mp="1gayqg58x449j">
            <ul className="mx-auto max-w-shell px-6 py-2 lg:px-10" data-id="element-143" data-mp="11l14zx2dhso1">
              {sections.map(s => {
            const isActive = location.pathname === s.path;
            return <li key={s.path} className="border-b border-white/8 last:border-b-0" data-id="element-144" data-mp="smfg7k6b5het">
                    <Link to={s.path} onClick={() => setOpen(false)} className={`flex items-baseline gap-4 py-3.5 text-sm transition-colors duration-150 ease-out ${isActive ? 'text-gold-soft' : 'text-white/75 hover:text-paper'}`} data-id="element-145" data-mp="nmknrc6vwjrn">
                      <span className="font-display text-[11px] text-gold-soft/70" data-id="element-146" data-mp="348rdsf2stwul">{s.number}</span>
                      {s.title}
                    </Link>
                  </li>;
          })}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}